export default __webpack_public_path__ + "static/media/leadAB.985e7aba.jfif";